/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { format, parseISO, eachDayOfInterval } from 'date-fns';
import { InfoRound, Search, Attachment } from '@rsuite/icons';

import { Table, FlexboxGrid, SelectPicker, IconButton, InputGroup, AutoComplete, Input, CheckPicker, Button } from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela1';
import { GerarCSV as CSV } from '~/utils/gerarCSV';
import moment from 'moment';
import api from '~/services/api';
import formatCurrency from '~/utils/formatCurrency';
import SearchInputTable from '~/components/SearchInputTable';
import useSearchNames from '~/services/useSearchNames';
import { ModalPadrao } from '~/components/Modal';
import { FiltroExperiencias } from '~/components/FiltroExperiencias';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import SelectState from '~/components/SelectState';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1'
import { TabelaPaginacao } from '~/components/TabelaPaginacao';
import { useDebouncedCallback } from 'use-debounce/lib';
import { MdLocationOn, MdOutlinePeopleOutline, MdTimer, MdWork } from 'react-icons/md';
import { InputDataRange } from '../../../components/InputDataRange';
import FiltroCidades from '../../Mensagens/components/FiltroCidades';
import FiltroBairros from '../../Mensagens/components/FiltroBairros';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function CadidatosGerais() {
  const [recrutamento, setRecrutamento] = useState({
    lista: [],
    quantidade: 0,
  });
  const [orderBy, setOrderBy] = useState()
  const [textodigitado, setTextoDigitado] = useState();
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [carregando2, setCarregando2] = useState(false);
  const [profissoes, setProfissoes] = useState([]);
  const [filtroEstabelecimento, setFiltroEstabelecimento] = useState();
  const [statusSelecionado, setStatusSelecionado] = useState();
  const [datas, setDatas] = useState();
  const [filtroServico, setFiltroServico] = useState();
  const [filtroCidades, setFiltroCidades] = useState([]);
  const [statusRecrutamento, setStatusRecrutamento] = useState([]);
  const [filtroBairros, setFiltroBairros] = useState([]);
  const [filtroProfissional, setFiltroProfissional] = useState();
  const [nomesEstabelecimentos, setNomesEstabelecimentos] = useState([]);
  const [nomesProfissionais, setNomesProfissionais] = useState([]);
  const [modalCSV, setModalCSV] = useState(false);
  const [buscarCSV, setBuscarCSV] = useState(false);
  const modalTitulo = 'Gerar CSV';
  const modalTexto =
    'Tem certeza que deseja gerar este CSV com os filtros atuais?';
  const locale = {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sab',
    ok: 'Ok',
    today: 'Hoje',
    yesterday: 'Ontem',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
  };

  const buscarRecrutamentoCandidatosGerais = useCallback(
    async (csv = false) => {
      setCarregando(true);
      setModalCSV(false);
      try {
        const resposta = await api.get('recrutamento-candidatos-gerais', {
          params: {
            pagina,
            id_cliente: filtroEstabelecimento,
            status: statusSelecionado,
            data: datas,
            servico: filtroServico,
            cidade: filtroCidades[0],
            bairro: filtroBairros[0],
            profissional: filtroProfissional,
            numero_rs: textodigitado,
            csv: buscarCSV,
            orderBy,
          },
        });
        const data = resposta.data.lista.map((item) => ({
          // ...item,
          ...(buscarCSV === false && item),
          nome_profissional: item.profissionais.nome,
          nome_fantasia: item.recrutamento.estabelecimento.nome_fantasia,
          funcao: item.recrutamento.profissoes.profissao,
          bairro_vaga: item.recrutamento.estabelecimento.endereco.bairro.bairro,
          cidade_vaga: item.recrutamento.estabelecimento.endereco.bairro.cidade.cidade,
          bairro_profissional: item.profissionais.endereco.bairro.bairro,
          cidade_profissional: item.profissionais.endereco.bairro.cidade.cidade,
          estado_profissional: item.profissionais.endereco.bairro.cidade.estado.estado,

        }));
        const listaCSV = data
        if (buscarCSV) {
          CSV({
            data: listaCSV,
            download: true,
          });

          setCarregando2(false);
          toast.success(`Foram exportados ${data.length} registros.`);
          setBuscarCSV(false);
          return;
        }

        setRecrutamento({
          lista: data,
          quantidade: resposta.data.quantidade,
        });

        if (recrutamento.quantidade > 0 && recrutamento.lista.length === 0) setPagina(1)
      } catch (e) {
        if (buscarCSV) {
          setCarregando2(false);
          toast.error('Erro ao Exportar os dados');
          setBuscarCSV(false);
          return;
        }
        toast.error(e.message);
      }
      setCarregando(false);
    }, [
    datas,
    pagina,
    statusSelecionado,
    filtroProfissional,
    filtroServico,
    filtroEstabelecimento,
    textodigitado,
    filtroCidades,
    filtroBairros,
    orderBy,
    buscarCSV,
    recrutamento.quantidade,
    setPagina,
    recrutamento.lista.length
  ]);

  const buscarStatusRecrutamento = useCallback(async () => {
    setCarregando(true);
    try {
      const resposta = await api.get('recrutamento-status');
      const data = resposta.data.map((item) => ({
        value: item.id, label: item.status
      }));


      setStatusRecrutamento(data);
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, []);


  useEffect(() => {
    buscarRecrutamentoCandidatosGerais();
    buscarStatusRecrutamento()
  }, [buscarRecrutamentoCandidatosGerais, buscarStatusRecrutamento]);

  useEffect(() => {
    const buscarDadosApi = async () => {
      try {
        const resposta = await api.get('profissao');
        setProfissoes(resposta.data);
      } catch (error) {
        toast.error(error.message);
      }
    };
    buscarDadosApi();
  }, []);

  const buscarNomesEstabelecimentos = useSearchNames(
    setNomesEstabelecimentos,
    'estabelecimentos',
    setFiltroEstabelecimento
  );

  const buscarNomesProfissionais = useSearchNames(
    setNomesProfissionais,
    'profissionais',
    setFiltroProfissional
  );
  const allValue = statusRecrutamento.map(item => item.value);

  const activeFilters = useMemo(() => {
    const filters = [];
    return filters;
  }, []);

  return (
    <Container>
      <PageHeader
        title="Candidatos Gerais RS"
        subtitle='Lista de todos os candidatos do Recrutamento e Seleção.'
        actions={(
          <div>
            <Button
              appearance="ghost"
              startIcon={<Attachment />}
              onClick={() => setModalCSV(true)}
            >Exportar CSV</Button>
          </div>
        )}
      />
      <MetricsCards
        items={[
          {
            title: 'Total de Profissionais',
            value: recrutamento.quantidade,
            icon: <MdOutlinePeopleOutline size='30px' />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Função com mais Candidaturas',
            value: '-',
            icon: <MdWork size='30px' />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Cidade com mais Candidatos',
            value: '-',
            icon: <MdLocationOn size='30px' />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Candidato a mais tempo esperando por uma vaga',
            value: '-',
            icon: <MdTimer size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <AutoComplete
              name="nome_estabelecimento"
              style={{ width: '180px' }}
              data={nomesEstabelecimentos.map((p) => ({
                label: p.nome_fantasia,
                value: p.nome_fantasia,
                id: p.id,
              }))}
              placeholder="Nome do Cliente"
              onSelect={async (value, item) => {
                setFiltroEstabelecimento(item.id);
              }}
              onChange={buscarNomesEstabelecimentos}
            />
            <CheckPicker
              value={statusSelecionado}
              placeholder="Status"
              searchable={false}
              data={statusRecrutamento}
              onChange={setStatusSelecionado}
            />
          </>
        }
      >

        <FlexboxGrid justify="start" style={{ gap: "10px" }}>
          <InputDataRange
            ranges={[]}
            // isoWeek
            value={datas}
            locale={locale}
            onChange={setDatas}
          />
          <SelectPicker
            name="id_profissao"
            placeholder="Serviço"
            value={filtroServico}
            data={profissoes.map((p) => {
              return {
                label: p.profissao,
                value: p.id,
              };
            })}
            onChange={setFiltroServico}
          />
          <InputGroup style={{ width: '150px' }}>
            <FiltroCidades
              setFiltroCidades={setFiltroCidades}
              onItemAdicionado={(value, item) => {
                const itemExiste = filtroCidades.find(
                  (filtro) => filtro.id === item.id
                );
                if (itemExiste) return;
                const lista = [item];
                setFiltroCidades(lista.map((p) => p.id));
              }}
            />
          </InputGroup>
          <InputGroup style={{ width: '150px' }}>
            <FiltroBairros
              setFiltroBairros={setFiltroBairros}
              onItemAdicionado={(value, item) => {
                const itemExiste = filtroBairros.find(
                  (filtro) => filtro.id === item.id
                );
                if (itemExiste) return;
                const lista = [item];
                setFiltroBairros(lista.map((p) => p.id));
              }}
            />
          </InputGroup>
          <InputGroup style={{ width: '180px' }}>
            <AutoComplete
              name="nome_profissional"
              width={100}
              data={nomesProfissionais.map((p) => ({
                label: p.nome,
                value: p.nome,
                id: p.id,
              }))}
              placeholder="Profissional"
              onSelect={async (value, item) => {
                setFiltroProfissional(item.id);
              }}
              onChange={buscarNomesProfissionais}
            />
          </InputGroup>
          <div>
            <InputGroup style={{ width: '140px' }}>
              <Input
                width={200}
                onChange={useDebouncedCallback(setTextoDigitado, 500).callback}
                placeholder="Número R"
              />

              <InputGroup.Button>
                <Search />
              </InputGroup.Button>
            </InputGroup>
          </div>
        </FlexboxGrid>
      </AdvancedFilters>

      <FlexboxGrid style={{ width: '100%' }}>

        <TablePagination
          carregando={carregando}
          dados={recrutamento.lista}
          quantidade={recrutamento.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >
          <Column resizable width={250} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Nome do Profissional' tooltip='Nome do Profissional' />
            </HeaderCell>
            <Cell dataKey="nome_profissional" />
          </Column>
          <Column resizable width={250} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Nome do Estabelecimento' tooltip='Nome do Estabelecimento' />
            </HeaderCell>
            <Cell dataKey="nome_fantasia" />
          </Column>
          <Column resizable width={130} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Função' tooltip='Função' />
            </HeaderCell>
            <Cell dataKey="funcao" />
          </Column>
          <Column resizable width={130} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Bairro da vaga' tooltip='Bairro da vaga' />
            </HeaderCell>
            <Cell dataKey="bairro_vaga" />
          </Column>
          <Column resizable width={140} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cidade da vaga' tooltip='Cidade da vaga' />
            </HeaderCell>
            <Cell dataKey="cidade_vaga" />
          </Column>
          <Column resizable width={170} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Bairro do Profissional' tooltip='Bairro do Profissional' />
            </HeaderCell>
            <Cell dataKey="bairro_profissional" />
          </Column>
          <Column resizable width={180} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cidade do Profissional' tooltip='Cidade do Profissional' />
            </HeaderCell>
            <Cell dataKey="cidade_profissional" />
          </Column>
          <Column resizable width={180} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Estado do Profissional' tooltip='Estado do Profissional' />
            </HeaderCell>
            <Cell dataKey="estado_profissional" />
          </Column>
        </TablePagination>
      </FlexboxGrid>
      <ModalPadrao
        openModal={modalCSV}
        carregando={carregando2}
        // csv
        setOpenModal={setModalCSV}
        title={modalTitulo}
        text={modalTexto}
        funcExec={() => {
          setBuscarCSV(true);
          buscarRecrutamentoCandidatosGerais();
        }}
      />
    </Container>
  );
}

export default CadidatosGerais;
